import React from 'react';
import classnames from 'classnames/bind';

import EnhancedContent from './components/EnhancedContent';

import styles from './SystemSettings.module.scss';

const cx: CX = classnames.bind(styles);

function SystemSettingsPage() {
    return (
        <div className={cx('page')}>
            <div className="container max-constraint center">
                <h1>
                    System Settings
                </h1>
                <EnhancedContent />
            </div>
        </div>
    );
}

export default SystemSettingsPage; 